import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCloserLocations = (closerLocations) => {
  return {
    type: actionTypes.SET_CLOSER_LOCATIONS,
    payload: closerLocations
  }
}
